import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

// TODO: update type to import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
// and follow up updateContactBlock or the IVR blocks work
const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.CustomTask).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.CustomTask);

export function CustomTaskBlock({ data }: { data?: any }): JSX.Element {
    const isActive = !!data?.task?.name || !!data?.empty;
    const nodeName = data?.task?.name || (isActive ? "Create Custom Task" : "Set custom task");
    const header = isActive ? "Agent Task" : "Create Custom Task";

    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={header}></BlockTitle>
            <BlockContent isActive={isActive}>{nodeName}</BlockContent>
        </BlockContainer>
    );
}
